(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-hero-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rp-video-player')) {
    class RpVideoPlayer extends HTMLElement {
      connectedCallback() {
        if (this._rpVideoInitialized) return;
        this._rpVideoInitialized = true;

        const video = this.querySelector('video');
        if (!video) return;

        const playButton = this.querySelector('[data-rp-play]');
        const muteButton = this.querySelector('[data-rp-mute]');
        const volumeInput = this.querySelector('[data-rp-volume]');
        const playIcon = this.querySelector('[data-rp-play-icon]');
        const pauseIcon = this.querySelector('[data-rp-pause-icon]');
        const volumeIcon = this.querySelector('[data-rp-volume-icon]');
        const mutedIcon = this.querySelector('[data-rp-muted-icon]');

        const configuredVolume = Number(this.dataset.defaultVolume);
        const initialVolume = Number.isFinite(configuredVolume)
          ? Math.min(1, Math.max(0, configuredVolume / 100))
          : 0.6;

        const autoplay = this.dataset.autoplay === 'true';
        const startMuted = this.dataset.startMuted === 'true' || autoplay;
        const videoLabel = this.dataset.videoLabel || 'Video';

        video.volume = initialVolume;
        video.muted = startMuted;
        video.setAttribute('aria-label', videoLabel);

        if (volumeInput) {
          volumeInput.value = String(Math.round(initialVolume * 100));
        }

        const updatePlayInterface = () => {
          const isPlaying = !video.paused && !video.ended;

          if (playButton) {
            playButton.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
          }
          if (playIcon) playIcon.hidden = isPlaying;
          if (pauseIcon) pauseIcon.hidden = !isPlaying;
        };

        const updateVolumeInterface = () => {
          const isMuted = video.muted || video.volume === 0;

          if (muteButton) {
            muteButton.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
            muteButton.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
          }
          if (volumeIcon) volumeIcon.hidden = isMuted;
          if (mutedIcon) mutedIcon.hidden = !isMuted;

          if (volumeInput && !video.muted) {
            volumeInput.value = String(Math.round(video.volume * 100));
          }
        };

        const togglePlayback = () => {
          if (video.paused || video.ended) {
            const playAttempt = video.play();
            if (playAttempt && typeof playAttempt.catch === 'function') {
              playAttempt.catch(updatePlayInterface);
            }
          } else {
            video.pause();
          }
        };

        if (playButton) {
          playButton.addEventListener('click', togglePlayback);
        }

        if (muteButton) {
          muteButton.addEventListener('click', () => {
            if (video.muted || video.volume === 0) {
              if (video.volume === 0) {
                video.volume = initialVolume > 0 ? initialVolume : 0.5;
              }
              video.muted = false;
            } else {
              video.muted = true;
            }
            updateVolumeInterface();
          });
        }

        if (volumeInput) {
          volumeInput.addEventListener('input', (event) => {
            const nextVolume = Math.min(1, Math.max(0, Number(event.target.value) / 100));
            video.volume = nextVolume;
            video.muted = nextVolume === 0;
            updateVolumeInterface();
          });
        }

        video.addEventListener('click', togglePlayback);
        video.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            togglePlayback();
          }
        });
        video.addEventListener('play', updatePlayInterface);
        video.addEventListener('pause', updatePlayInterface);
        video.addEventListener('ended', updatePlayInterface);
        video.addEventListener('volumechange', updateVolumeInterface);

        updatePlayInterface();
        updateVolumeInterface();

        if (autoplay) {
          const playAttempt = video.play();
          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(updatePlayInterface);
          }
        }
      }
    }

    customElements.define('rp-video-player', RpVideoPlayer);
  }
  } catch(e) { console.error(e); }
})();

})();
